// Single source of truth for the Live / Video type badge used across the
// Analytics dashboard (leaderboard rows, deep-link banner, selection chips).
//
// Follows the app's "live" convention: the `error` red token with a dot +
// label in a tinted pill (the "Stream live" status on the Highlights page, the
// LIVE overlay badge in Live Clipping, Badge.vue's tinted `*-transparent`
// treatment). Green `success` dots elsewhere in the app mean "ingest online",
// which is a different signal and not used here.
//
// Note: the colour tokens are CSS variables, so Tailwind opacity modifiers
// (`bg-error/10`) produce no CSS; use the `*-transparent` tokens instead.

export const TYPE_BADGE_BASE = 'inline-flex shrink-0 items-center gap-1 rounded-full px-1.5 text-[11px] font-medium leading-4';

const BADGES = {
	live: { label: 'Live', pill: 'bg-error-transparent text-error-light', dot: 'bg-error' },
	video: { label: 'Video', pill: 'bg-surface-3 text-surface-8', dot: 'bg-surface-7' },
};

/** 'live' -> Live badge; anything else (vod/unknown) -> the neutral Video badge. */
export function typeBadge(type) {
	return type === 'live' ? BADGES.live : BADGES.video;
}

export function typeLabel(type) {
	return typeBadge(type).label;
}

/** Dot-only variant for compact spots (selection chips). */
export function typeDotClass(type) {
	return `size-1.5 shrink-0 rounded-full ${typeBadge(type).dot}`;
}
